import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-valuation-result-header',
  templateUrl: './valuation-result-header.component.html',
 changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValuationResultHeaderComponent {}
